<template>
<div v-if="initialized">
  <v-stepper v-model="step" elevation="0">
    <v-stepper-items>
      <v-stepper-content step="1">
        <div class="text-center">
          <div class="text-h3 mb-2">Wo suchen Sie?</div>
          <div class="text-h4">Erstellen Sie ein Suchprofil und wir benachrichtigen Sie automatisch.</div>
        </div>
        <locations-container :selected-location-ids="selectedLocationIds" @update="setLocations" :map-center="mapCenter" :map-zoom="mapZoom">
          <template v-slot:header="slotProps">
            <v-container>
            <v-row align="center">
              <v-col cols="12" sm="12" class="text-center">
                <locations-menu @click="slotProps.toggle" :locations="slotProps.locations"></locations-menu>&nbsp;
                <v-btn @click="next" :disabled="locations.length == 0" large color="primary">Details eingeben <v-icon light right>$vuetify.icons.next</v-icon></v-btn>
              </v-col>
            </v-row>
            </v-container>
          </template>
        </locations-container>
      </v-stepper-content>

      <v-stepper-content step="2">
        <inquiry-categories
          v-if="maxStep >= 2"
          :category="category" @category="setCategory"
          :marketingType="marketingType" @marketingType="setMarketingType"
          :objectType="objectType" @objectType="setObjectType"
          :categoryList="config.categoryList"
          @next="next"
          :icons="true"
        >
          <template v-slot:navigationPrev>
          </template>
          <template v-slot:navigationNext>
          </template>
          <template v-slot:title>
            <div class="text-h3 mb-2">Was genau suchen Sie?</div>
          </template>
        </inquiry-categories>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-container v-if="maxStep >= 3" class="mb-1">
          <inquiry-fields @next="next" :fields="fields" :category="category" :marketing-type="marketingType" @fieldChanged="changeField">
            <template v-slot:title>
              <div class="text-h3 mb-4">Eckdaten und Details</div>
            </template>
          </inquiry-fields>
        </v-container>
      </v-stepper-content>

      <v-stepper-content step="4" v-if="contactForm">
        <v-container v-if="maxStep >= 4">
          <v-alert type="success" v-if="sent" class="mb-6">
            <strong>{{ $t('Ihre Anfrage wurde abgeschickt, bitte überprüfen Sie Ihr E-Mail-Postfach, um diese zu bestätigen.') }}</strong>
          </v-alert>

          <v-form @submit="submit" v-if="!sent">
            <v-alert type="error" v-if="error" class="mb-6">
              <strong>{{ $t('Es ist ein Fehler aufgetreten.') }}</strong>
            </v-alert>

            <v-alert type="error" v-if="userError" class="mb-6">
              <strong>{{ $t('Bitte prüfen Sie Ihre Eingaben.') }}</strong>
            </v-alert>

            <div class="text-h3 mb-4">Ihre Kontakdaten</div>

            <contact-form ref="contactForm"></contact-form>

            <div class="text-center mt-4 mb-1">
              <v-btn large @click="submit" outlined :loading="loading">{{ saveButtonText }}</v-btn>
            </div>
          </v-form>
        </v-container>
      </v-stepper-content>
    </v-stepper-items>

    <v-stepper-header v-if="!sent && showSteps">
      <v-stepper-step :complete="step > 1" step="1" editable color="primary" edit-icon="$check"></v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="step > 2" step="2" :editable="locations.length > 0" color="primary" edit-icon="$check"></v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="step > 3" step="3" :editable="locations.length > 0 && category != null" color="primary" edit-icon="$check"></v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="4" :complete="sent" :editable="locations.length > 0 && category != null" color="primary" edit-icon="$check"></v-stepper-step>
    </v-stepper-header>
  </v-stepper>

  <slot name="footer" v-bind:save="save" v-bind:isComplete="locations.length > 0 && category != null"></slot>
</div>
</template>

<script>
import LocationsMenu from "./LocationsMenu";
import LocationsContainer from "./LocationsContainer";
import InquiryCategories from "./InquiryCategories";
import InquiryFields from "./InquiryFields";
import ContactForm from "../ContactForm";
import config from "./ConfigSearchInquiry";
import inquiryFieldsConfig from "./InquiryFieldsConfig";

export default {
  name: "SavedSearchWizard",

  components: {
    LocationsMenu,
    LocationsContainer,
    InquiryCategories,
    InquiryFields,
    ContactForm
  },

  props: {
    "savedSearch": Object,
    "contactForm": {
      type: Boolean,
      default: true
    },
    "showSteps": {
      type: Boolean,
      default: true
    }
  },


  data() {
    return {
      initialized: false,
      marketingType: "buy",
      objectType: "LIVING",
      category: null,
      step: 1,
      maxStep: 1,
      locations: null,
      fields: [],
      config,
      userError: false,
      error: false,
      sent: false,
      selectedLocationIds: null
    }
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    saveButtonText() {
      if (this.savedSearch) {
        return "Änderungen speichern";
      }

      return "Suchprofil erstellen";
    },

    mapCenter() {
      if ("mapCenter" in this.$store.state.appConfig) {
        const p = this.$store.state.appConfig.mapCenter.split(",");
        let lat = parseFloat(p[0]);
        let lng = parseFloat(p[1]);
        return [lat, lng];
      }

      return null;
    },

    mapZoom() {
      if ("mapZoom" in this.$store.state.appConfig) {
        return parseInt(this.$store.state.appConfig.mapZoom);
      }

      return null;
    }
  },

  created() {
    this.$store.dispatch("loading", true);
    inquiryFieldsConfig(config, this.$store, t => {
        return this.$t(t);
      }).then(fieldsConfig => {
        this.fields = fieldsConfig;
        //this.category = this.config.categoryList[0];

        if (this.savedSearch) {
          if (this.savedSearch.categoryId) {
            this.config.categoryList.forEach(c => {
              if (c.id == this.savedSearch.categoryId) {
                if (c.objectType) {
                  this.objectType = c.objectType;
                }
                this.category = c;
              }
            });
          }
          if (this.savedSearch.marketingType) {
            this.marketingType = this.savedSearch.marketingType;
          }

          this.locations = this.savedSearch.locations;

          this.savedSearch.fields.forEach(field => {
            this.changeField({id: field.name, ds: field});
          });
        }

        if (this.locations != null) {
          this.selectedLocationIds = [];
          this.locations.forEach(location => {
            this.selectedLocationIds.push(location.locationId);
          });
        } else {
          this.locations = []; // select all
        }

        this.initialized = true;
        this.$store.dispatch("loading", false);
      });

      console.log(window.parentIFrame);
  },

  watch: {
    step(val) {
      if (val > this.maxStep) {
        this.maxStep = val;
      }

      if ("parentIFrame" in window) {
        window.parentIFrame.scrollToOffset(0, -200);
      }
    }
  },

  methods: {
    changeField(field) {

      const fields = [];
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].id == field.id) {
          const valueType = this.fields[i].ds.valueType;

          const newField = { ...this.fields[i] };
          newField.ds = { ...field.ds };
          newField.ds.valueType = valueType;

          fields.push(newField);
        } else {
          fields.push(this.fields[i]);
        }
      }

      this.fields = fields;
    },

    setLocations(locations) {
      this.locations = locations;
    },

    prev() {
      this.step--;
    },

    next() {
      this.step++;
    },

    setMarketingType(val) {
      this.marketingType = val;
    },

    setObjectType(val) {
      this.objectType = val;
      this.category = null;
    },

    setCategory(val) {
      this.category = val;
    },

    createSavedSearch() {
      const savedSearch = {
        objectType: this.objectType,
        categoryId: this.category.id,
        marketingType: this.marketingType,
        locations: [],
        fields: []
      };

      if (this.savedSearch) {
        savedSearch.uuid = this.savedSearch.uuid;
      }

      this.locations.forEach(l => {
        savedSearch.locations.push({
          locationId: l.locationId
        });
      })

      this.fields.forEach(f => {
        savedSearch.fields.push(f.ds);
      });

      return savedSearch;
    },

    save() {
      const savedSearch = this.createSavedSearch();
      this.$emit("save", savedSearch);
    },

    submit(e) {
      e.preventDefault();

      const contactForm = this.$refs.contactForm;

      if (!contactForm.validate()) {
        this.userError = true;
        return;
      }

      const savedSearch = this.createSavedSearch();

      const payload = {
        contact: contactForm.contact,
        savedSearch: savedSearch
      }

      let submitUrl = "/v1/wizard/saved-search";
      if ("submitUrl" in this.$store.state.appConfig) {
        submitUrl = this.$store.state.appConfig.submitUrl;
      }

      this.$store.dispatch("ajax", {
        url: submitUrl,
        method: "post",
        data: payload
      }).then(res => {
        this.sent = true;

        if ("parentIFrame" in window) {
          window.parentIFrame.sendMessage({
            opcode: "trackingEvent",
            event: "SavedSearchWizard"
          });
        }
      }).catch(err => {
        this.error = true;
      });
    }
  }
};
</script>
